import {
    CREATE_BOOKING_CLICKED,
    CREATE_BOOKING_CANCELLED,
    TRACK_EDIT_BOOKING_TIME_CLICKED,
    CREATE_BOOKING_STEPPER_STEP_CHANGED,
} from '../constants/analytics';

export const trackCreateBookingClick = () => {
    return {
        type: CREATE_BOOKING_CLICKED,
    };
};

export const trackCreateBookingCancel = (step) => {
    return {
        type: CREATE_BOOKING_CANCELLED,
        step,
    };
};

export const trackEditBookingTimeClick = (staticUId, caller) => {
    return {
        type: TRACK_EDIT_BOOKING_TIME_CLICKED,
        staticUId,
        caller,
    };
};

export const trackCreateBookingStepChange = (currentStep) => {
    return {
        type: CREATE_BOOKING_STEPPER_STEP_CHANGED,
        currentStep,
    };
};



// WEBPACK FOOTER //
// ./scripts/actions/analytics.js